export default __webpack_public_path__ + "static/media/cpr2.0b69b915.jpg";